/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from "react";

import { IToysrusEidboxEnData } from "./toysrus-eidbox-en.data";
import { IToysrusEidboxEnProps } from "./toysrus-eidbox-en.props.autogenerated";

export interface IToysrusEidboxEnViewProps
    extends IToysrusEidboxEnProps<IToysrusEidboxEnData> {
    budgetAmount: number;
    onBudgetAmountInput: (val: any) => void;
    isAgeSelected: boolean;
    isGenderSelected: boolean;
    giftfinderBack: () => void;
    giftfinderNext: () => void;
    getGiftSuggestions: () => void;
    onAgeInput: () => void;
    onGenderInput: () => void;
    ageGroups: IAgeGroup[];
    genderGroups: IGenderGroup[];
}

export interface IToysrusEidboxEnState {
    budgetAmount: number;
    isAgeSelected: boolean;
    isGenderSelected: boolean;
    selectedAgeGroups: string[];
    selectedGenderGroups: string[];

}

export interface IAgeGroup {
    ageLabel: string;
    ageValue: string;
    id: string;
    isChecked: boolean;
    containerClassName: string;
}

export interface IGenderGroup {
    genderLabel: string;
    genderValue: string;
    id: string;
    isChecked: boolean;
    containerClassName: string;
}


/**
 *
 * ToysrusEidbox component
 * @extends {React.PureComponent<IToysrusEidboxEnProps<IToysrusEidboxEnData>>}
 */
class ToysrusEidboxEn extends React.PureComponent<
    IToysrusEidboxEnProps<IToysrusEidboxEnData>,
    IToysrusEidboxEnState
> {
    public constructor(props: IToysrusEidboxEnViewProps) {
        super(props);

        this.state = {
            budgetAmount: 1,
            isAgeSelected: false,
            isGenderSelected: false,
            selectedAgeGroups: [],
            selectedGenderGroups: [],
        };
    }

    public render(): JSX.Element | null {
        var ageGroups: IAgeGroup[]  = [
            {
                ageLabel: "3-5 Years",
                ageValue: "3-5 Years",
                id: "c3",
                isChecked: this.state.selectedAgeGroups.findIndex(sag => sag === "3-5 Years") !== -1,
                containerClassName: "gift-finder-ageinput-container gift-finder-divcontainer1",
            },
            {
                ageLabel: "6-8 Years",
                ageValue: "6-8 Years",
                id: "c5",
                isChecked: this.state.selectedAgeGroups.findIndex(sag => sag === "6-8 Years") !== -1,
                containerClassName: "gift-finder-ageinput-container gift-finder-divcontainer2",
            }
        ]


        var genderGroups: IGenderGroup[]  = [
            {
                genderLabel: "Boy",
                genderValue: "Boy",
                id: "c2",
                isChecked: this.state.selectedGenderGroups.findIndex(sag => sag === "Boy") !== -1,
                containerClassName: "gift-finder-ageinput-container gift-finder-divcontainer2",
            },
            {
                genderLabel: "Girl",
                genderValue: "Girl",
                id: "c1",
                isChecked: this.state.selectedGenderGroups.findIndex(sag => sag === "Girl") !== -1,
                containerClassName: "gift-finder-ageinput-container gift-finder-divcontainer1",
            }
        ]

        return this.props.renderView({
            ...this.props,
            budgetAmount: this.state.budgetAmount,
            onBudgetAmountInput: this.onBudgetAmountInput,
            isAgeSelected: this.state.isAgeSelected,
            isGenderSelected: this.state.isGenderSelected,
            giftfinderBack: this.giftfinderBack,
            giftfinderNext: this.giftfinderNext,
            getGiftSuggestions: this.getGiftSuggestions,
            ageGroups: ageGroups,
            genderGroups: genderGroups,
            onAgeInput: this.updateSelectedAgeGroups,
            onGenderInput: this.updateSelectedGenderGroups
        });
    }

    public onBudgetAmountInput = (val: any) => {
        this.setState({ budgetAmount: val.currentTarget.value });
    };

    public giftfinderBack = () => {
        this.setState({ isAgeSelected: false });
    };

    public giftfinderNext = () => {
        this.updateSelectedAgeGroups();
        this.setState({ isAgeSelected: true });
    };

    public updateSelectedAgeGroups = () => {
        let checkboxes = document.querySelectorAll<HTMLInputElement>(
            'input[name="color"]:checked'
        );
        let selectedAgeGroups: string[] = [];
        checkboxes.forEach((checkBoxElement: HTMLInputElement) => {
            selectedAgeGroups.push(checkBoxElement.value);
        });

        this.setState({ selectedAgeGroups: selectedAgeGroups });
    };


    public updateSelectedGenderGroups = () => {
        let checkboxes = document.querySelectorAll<HTMLInputElement>(
            'input[name="gender"]:checked'
        );
        let selectedGenderGroups: string[] = [];
        checkboxes.forEach((checkBoxElement: HTMLInputElement) => {
            selectedGenderGroups.push(checkBoxElement.value);
        }); 

        this.setState({ selectedGenderGroups: selectedGenderGroups });
    };

    public getGiftSuggestions = () => {
      

        var ageGroupFilters: string[] = [];
        var genderGroupFilters: string[] = [];

        

        

        this.state.selectedAgeGroups.forEach((ageGroupValue: string) => {
           let ageGroupFilter = ageGroupValue;
            ageGroupFilters.push(ageGroupFilter);
        });

        this.state.selectedGenderGroups.forEach((genderGroupValue: string) => {
            let genderGroupFilter = genderGroupValue;
             genderGroupFilters.push(genderGroupFilter);
         });



        if (!ageGroupFilters || ageGroupFilters.length == 0) {
            var agefinalfilter = 'Null';
        } else {
            var agefinalfilter = ageGroupFilters[0];
        }



        if (!genderGroupFilters || genderGroupFilters.length == 0) {
            var genderfinalfilter = 'Null';
         } else {
            var genderfinalfilter = genderGroupFilters[0];
         }



   
         console.log(genderfinalfilter);
         console.log(agefinalfilter);

         if (genderfinalfilter=='Boy') {

            if (agefinalfilter=='3-5 Years') {
                window.location.assign("https://www.toysrus.com.sa/5637399578.c");
            } else {
                window.location.assign("https://www.toysrus.com.sa/5637401833.c");
            }

         } else {

            if (agefinalfilter=='3-5 Years') {
                window.location.assign("https://www.toysrus.com.sa/5637401834.c");
            } else {
                window.location.assign("https://www.toysrus.com.sa/5637401836.c");
            }
             
         }
     
         //   agefinalfilter = encodeURIComponent(agefinalfilter);
       // console.log(agefinalfilter);
        
       // window.location.assign("https://www.toysrus.com.sa/5637401833.c");

    };
}

export default ToysrusEidboxEn;
